import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { isAuthenticated, isAdmin } from '../store/action/auth';

const PublicRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={ props =>
      { 
        if (isAuthenticated()) {
          if (arrayOfPaths.includes(props.location.pathname)) {
            return <Component {...props} />  
          } else {
            return <Redirect to={{ pathname: '/overview', state: { from: props.location } }} />
          }
        
        } else {
          return <Component {...props} />
        }
      }}
  />
);

export default PublicRoute;

const arrayOfPaths = [
"/",
"/agent-registration",
"/complaints",
"/cek-ongkir",
"/cek-resi",
"/docs/api",
"/docs/api/authentication",
"/docs/api/errors",
"/docs/api/couriers",
"/docs/api/couriers/list",
"/docs/api/rates",
"/docs/api/orders",
"/docs/api/maps",
"/docs/api/maps/single_search_area",
"/docs/api/maps/double_search_area",
"/docs/api/rates/couriers_area_id",
"/docs/api/rates/couriers_postal_code",
"/docs/api/rates/couriers_coordinate",
"/docs/api/rates/couriers_mix",
"/forgot_password/new",
"/fulfillment",
"/help/faq",
"/new_password",
"/privacy",
"/pricing",
"/rates/courier",
"/shipping",
"/t/:shortOrderId",
"/plugin"]